import { Observable, of } from 'rxjs';

import { AutocompleteFunction } from '../../../../core/common/entities/autocompleteFunction.entity';
import { DroppanelStyle } from '../../../../elements/components/droppanel/entities/droppanel-style.entity';
import { FormSelectOption } from '../../../../form-controls/entities/form-select-option.entity';
import { MultiFormSelectStyle } from '../../../../form-controls/entities/multi-form-select-style.entity';
import { FilterType } from '../../base/entities/filter-type';
import { Filter } from '../../entities/filter.class';

export class MultiSelectFilter extends Filter {
    constructor(field: string) {
        super({ field, filterType: FilterType.MultiSelect });
    }

    options: FormSelectOption[] = [];
    search: boolean = false;
    multiple: boolean = true;

    searchPlaceholderMsg: string = '';
    noResultsFoundMsg: string = '';
    isLiveSearch: boolean = false;
    style: MultiFormSelectStyle = MultiFormSelectStyle.Default;
    droppanelStyle: DroppanelStyle = DroppanelStyle.Default;
    dottedKey: string = '';
    autocomplete: boolean = false;

    addValue(value: string): void {
        if (!value || typeof value !== 'string') {
            console.warn(value, 'is not in the correct format, must be string');
            return;
        }

        const option: string | undefined = this.options
            .map(formSelectOption => formSelectOption.value)
            .find(formValue => formValue === value);

        if (typeof option === 'string') {
            super.addValue(option);
        } else {
            console.warn(value, 'is not a valid option');
        }
    }

    searchFct(term: string): Observable<FormSelectOption[]> {
        return of(this.options);
    }

    autocompleteFct(dottedKey: string, term: string): AutocompleteFunction | any {
        return;
    }
}
